const SubTask = require('./SubTask');
const ONE_HOUR = 1000 * 60 * 60;
class Task {
    constructor() {
    }

    static fromRaw(raw) {
        let task = new Task();
        task.raw = raw;
        task.uuid = raw.uuid;
        task.type = raw.type;
        task.name = raw.name;
        task.status = raw.status;
        task.startTime = raw.startTime;
        task.taskExitMessage = raw.taskExitMessage;
        task.finishTime = raw.finishTime;
        task.progress = raw.progress;
        task.entityMap = raw.entityMap;
        task.createdTime = raw.createdTime;
        task.authorityEmail = raw.user;
        task.vmName = raw.virtualMachine;
        task.target = raw.target;
        task.source = raw.source;
        task.virtualMachineSnapshots = raw.virtualMachineSnapshots;
        task.subTasks = raw.subTasks ? raw.subTasks.map(SubTask.fromRaw) : [];
        task.childTasks = raw.childTasks ? raw.childTasks.map(Task.fromRaw) : [];
        task.childTasks.forEach(item => item.childTask = true);

        return task;
    }


    static getResourceGroupsKey() {
        return 'resourceGroup_name';
    }

    static getSearchKey() {
        return 'name';
    }

    static getStatusKey() {
        return 'status';
    }

    static getAuthorityKey() {
        return 'authority_identifier';
    }

    static getIdKey() {
        return 'id';
    }

    static getTimeRangeKey() {
        return 'created';
    }

    static getStatusOptions() {
        return [
            { label: 'Done', value: 'DONE' },
            { label: 'Ready', value: 'READY' },
            { label: 'Running', value: 'RUNNING' },
            { label: 'Failed', value: 'FAILED' },
            { label: 'Done with errors', value: 'DONE_WITH_ERRORS' },
            { label: 'Aborted', value: 'ABORTED' },
            { label: 'Aborting', value: 'ABORTING' },

        ];
    }


    static getTimeOptions() {
        return [
            { name: 'Last 1 hour', value: (ONE_HOUR).toString() },
            { name: 'Last 24 hours', value: (ONE_HOUR * 24).toString() },
            { name: 'Last week', value: (ONE_HOUR * 24 * 7).toString() },
        ];
    }

    toRaw() {
        return {
            uuid: this.uuid,
            type: this.type,
            name: this.name,
            status: this.status,
            taskExitMessage: this.taskExitMessage,
            startTime: this.startTime,
            finishTime: this.finishTime,
            subTasks: this.subTasks.map(j => j.toRaw()),
        };
    }
}

module.exports = Task;



// WEBPACK FOOTER //
// ./src/azurebackup/model/Task.js